<template>
  <v-card class="pa-6" relative>
    <v-btn icon class="btn-close" @click="$emit('close')">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <h3 class="mb-4 primary--text">Import template reviews from a spreadsheet</h3>
    <p>
      Download the
      <a
        href="https://minio.lattef.co/lattedrop/static/20231111/template-review.csv"
        target="_blank"
        class="primary--text"
      >
        Import File Template.</a
      >
      <br />
      Fill in the reviews data you’d like to import and verify that your file meets all the requirements stated in the
      template. <br />
      Reviews that do not comply with the instructions will not be imported.
    </p>
    <v-file-input
      ref="fileUploader"
      accept=".csv"
      type="file"
      placeholder="File csv"
      outlined
      dense
      v-model="reviewFile"
    />
    <div class="d-flex justify-end mt-4">
      <v-btn color="primary" @click="$emit('close')" text>Cancel</v-btn>
      <v-btn color="primary" :loading="isLoading" :disabled="!reviewFile" @click="onImport" text>Import</v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '@/common/api.service'

export default {
  data() {
    return {
      reviewFile: null,
      isLoading: false,
    }
  },
  methods: {
    async onImport() {
      try {
        this.isLoading = true
        const formData = new FormData()
        formData.append('file', this.reviewFile)
        await ApiService.post('/reviews/import/template', formData)
        this.$emit('close')
      } catch (error) {
        console.log('🚀 ~ file: ReviewCard.vue:76 ~ onImport ~ error:', error)
        this.$store.commit('setMessages', {
          type: 'error',
          messages: 'Csv file is invalid',
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
h1 {
  text-transform: unset !important;
}
.btn-close {
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>
